// Shared formatting of the broker-report-sync screens (screens.md §Спільне для всіх екранів).

const PROVIDER_NAMES = {
  FREEDOM_FINANCE: "Freedom Finance",
  INTERACTIVE_BROKERS: "Interactive Brokers",
};

export const providerName = (dataProvider) => PROVIDER_NAMES[dataProvider] || dataProvider || "";

// The broker's account number in full (decision 2026-10-16, screens.md §Спільне); long ones wrap with break-all.
export const accountNumber = (originalId) => (originalId ? String(originalId) : "");

// «Freedom Finance FF-7734821».
export const accountTitle = ({ dataProvider, originalId }) =>
  [providerName(dataProvider), accountNumber(originalId)].filter(Boolean).join(" ");

// дд.мм.рррр from a LocalDateTime / date-time / date string, read as written (no time zone shift).
export function formatDate(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || "");
  return match ? `${match[3]}.${match[2]}.${match[1]}` : "";
}

export const formatPeriod = (start, end) => `${formatDate(start)} – ${formatDate(end)}`;

export const sizeInKb = (bytes) => Math.round((bytes || 0) / 1024);
